module.exports = __webpack_public_path__ + "img/no-authen-tips.7dac5d53.png";